function CheckScroll() {
  if (window.scrollY >= 50) {
    $("body").addClass("scrolling");
  } else {
    $("body").removeClass("scrolling");
  }
}

$(window).scroll(function () {
  CheckScroll();
});

$(document).ready(function () {
  CheckScroll();

  var $slicks = $("[data-slick]");
  if ($slicks.length > 0) {
    $slicks.slick();
  }

  $(".footer-link").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).next(".footer-content").slideToggle(150);
  });
});
